
import { listDataComment, deleteComment, saveComment } from '@/zsm-api-new/comment.js'
const state = {
  editComment: '', // 编辑内容
  replyComment: '', // 回复
  replyDialog: false, // 编辑弹框
  editCommentDialog: false, // 回复弹框
  addCommentDialog: false, // 添加评论弹框
  commentByCourse: '', // 课程信息
  commentDialog: false // 评价的弹框

}

const mutations = {
}

const actions = {
  // 查看评价列表
  listDataComment({ commit }, info) {
    return new Promise((resolve, reject) => {
      listDataComment(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 删除评价列表
  deleteComment({ commit }, info) {
    return new Promise((resolve, reject) => {
      deleteComment(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 新增评价或修改评价
  saveComment({ commit }, info) {
    return new Promise((resolve, reject) => {
      saveComment(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
